import { createSelector } from 'reselect';

import { Selectors as ResponsesGetAllWorkersSelectors } from 'app/redux/responses/get-all/workers';
import { getSelectedAnswers } from 'app/redux/ui/questions/selectors';

const getResponsePoints = selectedAnswers => {
  const responseArray = Object.keys(selectedAnswers);

  if (!responseArray.length) return 0;

  return responseArray.reduce((acc, answer) => {
    const selectedScore = selectedAnswers[answer].score || 0;

    return parseInt(selectedScore, 10) + acc;
  }, 0);
};

const getResponsePercentagePoints = pointTotal => {
  const points = pointTotal > 100 ? 100 : pointTotal;
  const resultAsDecimal = points / 100;
  const resultAsPercentage = Math.floor(resultAsDecimal * 100);

  return {
    resultAsDecimal,
    resultAsPercentage,
  };
};

const getAssignedResponse = (responses, points) => {
  if (!responses) return;

  const pointsAsString = points.toString();
  const pointLength = pointsAsString.length;
  const roundedPoints = pointLength === 1 ? '0' : pointsAsString.slice(0, -1);
  const cappedPoints = roundedPoints > 9 ? '9' : roundedPoints;

  const assignedResponse = responses.find(response => {
    return response.pointRange === cappedPoints;
  });

  return assignedResponse && assignedResponse.response;
};

const isWorking = createSelector(
  ResponsesGetAllWorkersSelectors.isWorking,
  isGetAllResponsesWorking => isGetAllResponsesWorking
);

const Selectors = createSelector(
  ResponsesGetAllWorkersSelectors.result,
  getSelectedAnswers,
  isWorking,
  (responsesResults, selectedAnswers, isWorking) => {
    const responsePointTotal = getResponsePoints(selectedAnswers);
    const responsePoints = getResponsePercentagePoints(
      responsePointTotal,
      selectedAnswers
    );
    const assignedResponse = getAssignedResponse(
      responsesResults && responsesResults.responses,
      responsePointTotal
    );

    return {
      assignedResponse,
      isWorking,
      responsePoints,
    };
  }
);

export default Selectors;



// WEBPACK FOOTER //
// ./src/redux/ui/results/selectors.js